import React from "react";
import SEO from "../../Components/SEO";
import Breadcrumb from "../../Components/Breadcrumb";
import { ActivityLayout } from "../../Components/activity-layout";
import ActivityFilter from "../../Shared/activityFilter";
import readingcomp from "./Data/readingcomp.jsx";

const reading = '/Images/reading1-1280x470.webp';

const Readingexercises = () => {
    return (
        <ActivityLayout
            title="Reading Exercises"
            image={reading}
            intro="Improve your reading skills with our categorized practice exercises. Browse through different exam tasks including comprehension, paragraph headings, and interactive grammar identification — all organized by level."
        >
            <SEO
                title="Free English Reading Exercises and Comprehension Practice"
                description="Reading comprehension practice for Cambridge English, IELTS and other exams. Exercises by CEFR level A1-C1: skim and scan, paragraph headings, true/false and interactive grammar identification."
                name="Reading English Exam Exercises"
                type="article"
                image={reading}
            />
            <Breadcrumb />
            <ActivityFilter
                data={readingcomp}
                getLink={(item) => `/reading-exercises/reading-comprehension?readingcompTitle=${encodeURIComponent(item.title)}`}
                ctaLabel="Start Exercise"
                resultsLabel="exercises"
                itemsPerPage={6}
            />
        </ActivityLayout>
    );
};

export default Readingexercises;
